import React, { useContext } from 'react'
import { dateCol, intCol, numCol, strCol } from '@integec/grid-tools/lib/cols'
import CommonScreen from '../admin/component/CommonScreen'
import { getScheduleDetails } from '../api/pgads'
import {
  getApiTargetInfo,
  getEnvConfig,
  getPermitActions,
  getUnits,
  isValidYearRange,
} from 'core'
import { connect } from 'react-redux'
import { DatePicker } from 'antd'
import { DatePickerContext, PNodeZoneContext } from 'context'
import {
  modifiedDateCol,
  modifierCol,
  unitIdHeader,
} from 'core/HeaderColTypeProps'

const title = 'Schedule Detail'

const ScheduleDetail = () => {
  const { selectedDateRangePicker, setSelectedDateRagePicker } = useContext(
    DatePickerContext
  )
  const {
    unitIdEmktIdMap,
    emktIdUnitNameMap,
    // marginUnitsList,
    emktUnits,
  } = useContext(PNodeZoneContext)

  const screenCriteria = (s, p, u, onChange) => {
    return (
      <DatePicker.RangePicker
        style={{ marginLeft: '15px' }}
        allowClear={false}
        format="MM/DD/YYYY"
        value={selectedDateRangePicker}
        onChange={d => {
          setSelectedDateRagePicker(d)
          onChange()
          // retrieve({ dates: d })
        }}
      />
    )
  }

  const withCriteria = (state, props, selectedUnits = []) => ({
    unitid: selectedUnits.map(u => u.unitId).map(id => unitIdEmktIdMap[id]),
    startdate: selectedDateRangePicker[0],
    enddate: selectedDateRangePicker[1],
  })

  const extraUnitSelectionProps = _ => ({
    limitedUnits: emktUnits,
    units: emktUnits,
    // itemToLabel: e => e.emktId,
  })

  const headerWithFormatter = OaScheduleDetailHeaders.map(header =>
    header.ident === 'unitId' || header.ident === 'unitid'
      ? {
          ...header,
          dataFormatter: ({ value }) => emktIdUnitNameMap[value] || value,
          sortIndexGetter: ({ rowData }) =>
            emktIdUnitNameMap[rowData.unitId] ||
            emktIdUnitNameMap[rowData.unitid] ||
            rowData.unitId ||
            rowData.unitid,
        }
      : header
  )

  const beforeRetrieveValidation = ({ validYearRange }) => {
    return isValidYearRange(
      validYearRange,
      selectedDateRangePicker[0],
      selectedDateRangePicker[1]
    )
  }

  return (
    <CommonScreen
      beforeRetrieveValidation={beforeRetrieveValidation}
      headerRowHeight={60}
      extraUnitSelectionProps={extraUnitSelectionProps}
      screenCriteria={screenCriteria}
      withCriteria={withCriteria}
      withUnitSelection
      isAdminScreen={false}
      title={title}
      header={headerWithFormatter}
      retrieveTask={getScheduleDetails}
      altBy={d => d.unitid}
      autoRetrieve={false}
      sortOptions={OaScheduleDetailHeaders}
      widthOffset={100}
      heightOffset={270}
      insertComp={false}
      insertCompHeight={0}
      onInsertEvent={_ => _}
      allowInsert={false}
      withoutModify
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
  units: getUnits(state),
})

export default connect(mapStateToProps)(ScheduleDetail)

export const OaScheduleDetailHeaders = [
  // strCol({ ident: 'companyId', display: 'CompanyId', isFiltered: true }),
  unitIdHeader,
  // strCol({ ident: 'unitId', display: 'Unitid', isKey: true }),

  dateCol({
    ident: 'transdate',
    display: 'Transdate',
    isKey: true,
    sortOrder: 'asc',
  }),
  intCol({
    ident: 'schedule',
    display: 'Schedule',
    isKey: true,
    sortOrder: 'asc',
  }),
  strCol({ ident: 'market', display: 'Market', isKey: true, sortOrder: 'asc' }),
  numCol({
    ident: 'ecoMinmw',
    display: 'Eco Min MW',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'ecoMaxmw',
    display: 'Eco Max MW',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({ ident: 'emerMinmw', display: 'Emer Min MW', isFiltered: true }),
  numCol({ ident: 'emerMaxmw', display: 'Emer Max MW', isFiltered: true }),
  // strCol({
  //   ident: 'useStartupNoload',
  //   display: 'Use Startup Noload',
  //   isFiltered: true,
  // }),
  numCol({
    ident: 'noloadCost',
    display: 'No Load Cost ($)',
    isFiltered: true,
  }),
  numCol({
    ident: 'hotstartupCost',
    display: 'Hot Startup Cost ($)',
    isFiltered: true,
  }),
  numCol({
    ident: 'interstartupCost',
    display: 'Inter Startup Cost ($)',
    isFiltered: true,
  }),
  numCol({
    ident: 'coldstartupCost',
    display: 'Cold Startup Cost',
    isFiltered: true,
  }),
  // strCol({ ident: 'primaryFuel', display: 'Primary Fuel', isFiltered: true }),
  // strCol({ ident: 'subFuel', display: 'Sub Fuel', isFiltered: true }),
  numCol({ ident: 'minRuntime', display: 'Min Run Time', isFiltered: true }),
  numCol({ ident: 'maxRuntime', display: 'Max Run Time', isFiltered: true }),
  numCol({ ident: 'minDowntime', display: 'Min Down Time', isFiltered: true }),
  numCol({
    ident: 'hottocoldTime',
    display: 'Hot to Cold Time',
    isFiltered: true,
  }),
  numCol({
    ident: 'hottointerTime',
    display: 'Hot to Inter Time',
    isFiltered: true,
  }),
  numCol({
    ident: 'coldstartupTime',
    display: 'Cold Startup Time',
    isFiltered: true,
  }),
  numCol({
    ident: 'interstartupTime',
    display: 'Inter Startup Time',
    isFiltered: true,
  }),
  numCol({
    ident: 'hotstartupTime',
    display: 'Hot Startup Time',
    isFiltered: true,
  }),
  // numCol({
  //   ident: 'coldnotifTime',
  //   display: 'Cold Notif Time',
  //   isFiltered: true,
  // }),
  // numCol({
  //   ident: 'internotifTime',
  //   display: 'Inter Notif Time',
  //   isFiltered: true,
  // }),
  // numCol({
  //   ident: 'hotnotifTime',
  //   display: 'Hot not if Time',
  //   isFiltered: true,
  // }),
  numCol({
    ident: 'maxdailyStarts',
    display: 'Max Daily Starts',
    isFiltered: true,
  }),
  // numCol({
  //   ident: 'maxweeklyStarts',
  //   display: 'Max Weekly Starts',
  //   isFiltered: true,
  // }),
  // numCol({
  //   ident: 'maxdailyEnergy',
  //   display: 'Max Daily Energy',
  //   isFiltered: true,
  // }),
  // numCol({
  //   ident: 'maxweeklyEnergy',
  //   display: 'Max Weekly Energy',
  //   isFiltered: true,
  // }),
  modifierCol,
  modifiedDateCol,
]
